import React from "react";
import { CircularProgress } from "@mui/material";

const LoadingCircularProgress = ({ showReport }) => {

    return <div
        style={{
            position: "absolute",
            top: showReport ? "60%" : "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000, // Ensure spinner is on top of other content
            backgroundColor: "rgba(255, 255, 255, 0.8)", // Optional: adds a semi-transparent background
            borderRadius: "4px", // Optional: for a rounded look
            padding: "10px", // Optional: adds padding around the spinner
        }}
    >
        <CircularProgress size={"2rem"} />
        <span>Loading...</span>
    </div>
};

export default LoadingCircularProgress;
